//Libraries
import _ from 'lodash'
import moment from 'moment'
import axios from 'axios'

//Components
import Section from '../../components/section'
import Header from '../../components/pageHeader'
import LongPress from '../../components/longPress'
import SectionSpacing from '../../components/sectionSpacing'
import { AiOutlineEdit } from 'react-icons/ai'
import { AiOutlineDelete } from 'react-icons/ai'

//Styling
import './themes.scss'
import '../../dashboard.scss'

//Functions and Data
import config from './config'
import baseconfig from '../../../../variables/config'
import React, { useEffect, useState, useCallback } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { fetchClasses } from '../../../../modules/classes'
import { sendRequest } from '../../../../modules/admin'
import S3 from 'react-aws-s3'
import Dropzone from 'react-dropzone'

function Themes({ isOpen, sendRequest, classes }) {
  const [tab, setTab] = useState(0)
  const [tabs, setTabs] = useState([])
  const [showItems, setShowItems] = useState([])
  const [toggle, setToggle] = useState('')
  const [image, setImage] = useState('')
  const [content, setContent] = useState('')
  const [editSwitch, setEditSwitch] = useState(-1)

  useEffect(() => {
    sendRequest(fetchClasses)
    fetchAdditionsList()
    var cb = i => setTab(i)
    setTabs([{ name: '', cb: () => cb(0) }])
  }, [])

  const imageConfig = {
    bucketName: 'wackykingdom',
    dirName: 'media' /* optional */,
    region: 'eu-west-2',
    accessKeyId: process.env.REACT_APP_S3Key,
    secretAccessKey: process.env.REACT_APP_S3SecretAccessKey,
    s3Url: 'https://wackykingdom.s3.eu-west-2.amazonaws.com' /* optional */
  }

  const uploadImage = file => {
    const ReactS3Client = new S3(imageConfig)
    /*  Notice that if you don't provide a dirName, the file will be automatically uploaded to the root of your bucket */
    // console.log(imageConfig, "config");
    // console.log(file[0], "file");

    /* This is optional */
    const newFileName =
      'themes-' + JSON.stringify(Date.now()) + '-' + file[0].name

    ReactS3Client.uploadFile(file[0], newFileName)
      .then(data => {
        const classes = [...showItems]
        classes[editSwitch].image = data.location
        setImage(data.location)
        setShowItems(classes)
      })
      .catch(err => console.error(err))

    /**
     * {
     *   Response: {
     *     bucket: "myBucket",
     *     key: "image/test-image.jpg",
     *     location: "https://myBucket.s3.amazonaws.com/media/test-file.jpg"
     *   }
     * }
     */
  }

  const itemStructure = {
    name: 'Item Name',
    description: [],
    colour: 'green',
    image: 'Upload Image',
    price: 0
  }

  const fetchAdditionsList = async () => {
    let token = JSON.parse(window.localStorage.getItem('userData')).token
    const extraItems = (await axios.get(
      baseconfig.serverURL + '/ThemeItems' + '?access_token=' + token
    )).data
    setShowItems(extraItems)
  }

  const addItem = () => {
    var newItems = [...showItems]
    newItems.push(itemStructure)
    setShowItems(newItems)
  }

  const updateItem = async i => {
    if (!showItems[i].id) {
      let token = JSON.parse(window.localStorage.getItem('userData')).token
      let response = {}
      try {
        response = await axios.post(
          baseconfig.serverURL + '/ThemeItems',
          showItems[i]
        )
        setEditSwitch(-1)
        fetchAdditionsList()
      } catch (err) {
        if (response.data.status === 'success') {
          console.log('response ok')
        } else {
          throw new Error('Please fill all fields')
        }
      }
    } else {
      let token = JSON.parse(window.localStorage.getItem('userData')).token
      let response = {}
      try {
        response = await axios.patch(
          baseconfig.serverURL +
            '/ThemeItems/' +
            showItems[i].id +
            '?access_token=' +
            token,
          showItems[i]
        )
        setEditSwitch(-1)
        fetchAdditionsList()
      } catch (err) {
        if (response.data.status === 'success') {
          console.log('response ok')
        } else {
          throw new Error('Please fill all fields')
        }
      }
    }
  }

  const deleteItem = async i => {
    if (window.confirm('Are you sure you want to delete?')) {
      let token = JSON.parse(window.localStorage.getItem('userData')).token
      let response = []
      try {
        response = await axios.delete(
          baseconfig.serverURL +
            '/ThemeItems/' +
            showItems[i].id +
            '?access_token=' +
            token
        )
        setEditSwitch(-1)
        fetchAdditionsList()
      } catch (err) {
        if (response.data.status === 'success') {
          console.log('response ok')
        } else {
          throw new Error(response.data.error)
        }
      }
    } else {
      console.log('cancel ok')
    }
  }

  const handleContent = event => {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    setContent(value)
  }

  const handleChange = (event, index) => {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name
    var newData = { ...showItems[editSwitch] }
    var newItems = [...showItems]

    newData[name] = value
    newItems[editSwitch][name] = value
    setShowItems(newItems)
  }

  const addContent = (option, i) => {
    var newItems = [...showItems]
    newItems[i][option].push(content)
    setShowItems(newItems)
    setToggle('')
    setContent('')
  }

  var itemsList = showItems.map((item, index) => (
    <div className="orderContent" key={index}>
      {editSwitch === index ? (
        <li>
          <span>
            <label>Name:</label>
            <input
              value={item.name}
              name="name"
              className="column"
              placeholder="name"
              onChange={handleChange}
            />
          </span>
          <br />

          <span>
            <label>Description:</label>
            <textarea
              value={item.description}
              name="description"
              className="column"
              placeholder="Desc"
              onChange={handleChange}
            />
            {/* {item.description.length > 0 ? (
              item.description.map((d, i) => (
                <textarea
                  key={i + 'desc'}
                  value={d}
                  className="column"
                  rows="5"
                  name="description"
                  placeholder=""
                  onChange={event => handleChange(event, i)}
                />
              ))
            ) : (
              <span />
            )} */}

            {toggle === 'description' ? (
              <div>
                <button onClick={() => addContent('description', index)}>
                  Save
                </button>
                <button onClick={() => setToggle('')}>Remove</button>
              </div>
            ) : (
              <span></span>
            )}
          </span>

          <span>
            <label>Colour:</label>
            <input
              value={item.colour}
              name="colour"
              className="column"
              placeholder=""
              onChange={handleChange}
            />
          </span>
          <br />
          <span>
            <label>Image:</label>
            <input
              value={item.image}
              name="image"
              className="column"
              placeholder=""
              onChange={handleChange}
            />
          </span>
          <Dropzone onDrop={acceptedFiles => uploadImage(acceptedFiles)}>
            {({ getRootProps, getInputProps }) => (
              <section>
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <button>Upload Image</button>
                </div>
              </section>
            )}
          </Dropzone>
          <br />
          <label>Hide:</label>
          <label className="switch">
            <input
              type="checkbox"
              name="isHidden"
              checked={item.isHidden}
              onChange={handleChange}
            />
            <span className="slider round"></span>
          </label>
          <br />
          <span>
            <label>Price:</label>
            <input
              value={item.price}
              name="price"
              className="column"
              placeholder=""
              onChange={handleChange}
            />
          </span>

          <div className="orderOperation">
            <button onClick={() => setEditSwitch(-1)}>{'Cancel'}</button>
            <button onClick={() => updateItem(index)}>{'Save'}</button>
          </div>
        </li>
      ) : (
        <li>
          <h3>{item.name} </h3>
          {item.image.length > 0 && item.image != 'none' ? (
            <div className="list">
              Image:{' '}
              <img
                src={item.image}
                width="auto"
                height="80"
                style={{ display: 'inline' }}></img>
            </div>
          ) : (
            <div className="column">Desc: {item.description[0] + '...'}</div>
          )}
          <div className="column">Price: {item.price}</div>
        </li>
      )}
      <div className="orderOperation">
        <button onClick={() => deleteItem(index)}>{'Delete'}</button>

        {editSwitch === index ? (
          <button onClick={() => updateItem(index)}>{'Save'}</button>
        ) : (
          <button onClick={() => setEditSwitch(index)}>{'Edit'}</button>
        )}
      </div>
    </div>
  ))

  return (
    <div className="ordersContainer">
      <Header
        title={config.mainTitle}
        tip={config.subHeading}
        icon={config.titleIcon}
        tabs={tabs}
        selected={tab}
      />
      <div className="orderList">{itemsList}</div>
      <button onClick={() => addItem()}>{'Add New Item'}</button>
    </div>
  )
}

const mapStateToProps = ({ classes }) => ({
  classes: classes
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({ sendRequest }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Themes)
